module.exports = __webpack_public_path__ + "img/contact.8714635b.png";